@if (res && [queryData$ | async, persistData$ | async]) {
  <div class="user-settings-body">
    @if (!errorMessage) {
      <abc-form [formData]="user" labelMode="floating" id="dxForm" (onFieldDataChanged)="onFieldDataChanged($event)">
        @if (allowUserNameChange) {
          <dxi-item itemType="group" [caption]="res.get('UserSettings-MUser')">
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="name"
              [editorOptions]="{ valueChangeEvent: 'input', disabled: isPending || isPasswordChanged }"
            >
              <dxo-label [text]="res.get('UserSettings-Name')"></dxo-label>
            </dxi-item>
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="email"
              [editorOptions]="{ valueChangeEvent: 'input', disabled: isPending || isPasswordChanged }"
            >
              <dxo-label [text]="res.get('UserSettings-EMail')"></dxo-label>
            </dxi-item>
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="login"
              [editorOptions]="{ readOnly: true, disabled: isPending || isPasswordChanged }"
            >
              <dxo-label [text]="res.get('UserSettings-Login')"></dxo-label>
            </dxi-item>
            <dxi-item itemType="empty"></dxi-item>
            <dxi-item
              [cssClass]="getSubmitButtonClass()"
              itemType="button"
              [buttonOptions]="{
                text: res.get('UserSettings-Save'),
                disabled: isPending || !isUserChanged || !isUserValid || isPasswordChanged,
                onClick: saveUser,
              }"
            >
            </dxi-item>
          </dxi-item>
        }
        @if (allowPasswordChange) {
          <dxi-item itemType="group" [caption]="getAuthenticationCaption()">
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="password.currentPassword"
              [editorOptions]="{
                valueChangeEvent: 'input',
                mode: 'password',
                inputAttr: { autocomplete: 'new-password' },
                disabled: isPending || isUserChanged,
                buttons: currentPasswordTextBoxButton,
              }"
            >
              <dxo-label [text]="res.get('UserSettings-CurrentPW')"></dxo-label>
            </dxi-item>
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="password.newPassword"
              [editorOptions]="{
                valueChangeEvent: 'input',
                mode: 'password',
                inputAttr: { autocomplete: 'new-password' },
                disabled: isPending || isUserChanged,
                buttons: newPasswordTextBoxButton,
              }"
            >
              <dxo-label [text]="res.get('UserSettings-NewPW')"></dxo-label>
            </dxi-item>
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="password.confirmPassword"
              [editorOptions]="{
                valueChangeEvent: 'input',
                mode: 'password',
                inputAttr: { autocomplete: 'new-password' },
                disabled: isPending || isUserChanged,
                buttons: confirmPasswordTextBoxButton,
              }"
            >
              <dxo-label [text]="res.get('UserSettings-ConfirmPW')"></dxo-label>
            </dxi-item>
            <dxi-item itemtype="empty">
              <div class="passwordRequirementsTitle">
                <abc-icon
                  [color]="
                    isNewPasswordValid
                      ? 'var(--success-color, var(--DarkGreenColor))'
                      : 'var(--primary-light-color, var(--PrimaryMainShading10))'
                  "
                  [class]="isNewPasswordValid ? 'success' : 'default'"
                  [svgIcon]="res.svgUrl('check-mark-image')"
                ></abc-icon>
                <p>{{ res.get('UserSettings-PasswordRequirements') }}</p>
              </div>
              <ul class="passwordRequirementsList">
                @for (req of passwordRequirementsWarnings; track req) {
                  <li class="req">{{ req }}</li>
                }
              </ul>
            </dxi-item>
            <dxi-item
              [cssClass]="getSubmitButtonClass()"
              itemType="button"
              [buttonOptions]="{
                text: res.get('UserSettings-ChangePassword'),
                disabled: isPending || !isPasswordValid || isUserChanged,
                onClick: changePassword,
              }"
            >
            </dxi-item>
            @if (!allowUserNameChange) {
              <dxi-item
                [cssClass]="getCancelButtonClass()"
                itemType="button"
                [buttonOptions]="{
                  text: res.get('UserSettings-Cancel'),
                  onClick: cancelPasswordChange,
                }"
              >
              </dxi-item>
            }
          </dxi-item>
        }
      </abc-form>
    } @else {
      <div>{{ errorMessage }}</div>
    }
  </div>
}
